import { FC } from "react";
import { STANDARD_ICONS_LIST } from "../account/constants";

interface VehicleStandardIconSelectorProps {
  onSelect: (iconKey: string) => void;
  selectedIcon?: string;
}

const VehicleStandardIconSelector: FC<VehicleStandardIconSelectorProps> = ({
  onSelect,
  selectedIcon,
}) => {
  return (
    <div className="absolute top-full mt-2 z-50">
      <div className="inline-grid grid-cols-8 p-5 gap-y-6 gap-x-7 bg-white rounded-xl border border-gray-200 shadow-2xl min-w-max">
        {STANDARD_ICONS_LIST.map((item) => {
          const isSelected = selectedIcon === item.key;

          return (
            <button
              key={item.key}
              type="button"
              onClick={() => onSelect(item.key)}
              className={`flex items-center justify-center size-10 rounded-lg border-2 transition-all 
                ${
                  isSelected
                    ? "border-accent-blue-dark bg-accent-blue-pale/30"
                    : "border-gray-50 hover:border-gray-300 bg-white"
                }`}
            >
              <img
                src={item.icon}
                alt={item.key}
                className={`size-8 ${isSelected ? "" : "opacity-70 grayscale"}`}
              />
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default VehicleStandardIconSelector;
